import { Input, Button, Form, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { USER_ROLES, UserService, setCurrentUser } from '../../services/User';
import { useForm } from 'antd/es/form/Form';

const Login = () => {

    const navigate = useNavigate();
    const [form] = useForm();

    const login = async (values: any) => {
        const { email, password } = values;
        try{
            const response = await UserService.login(email, password);
            setCurrentUser(response.data.user)
            navigate('/', {replace: true})
        } catch(error){
            console.log(error)
        }
    };

    const resetPasswordLink = async () => {
        const email = form.getFieldValue("email");
        await UserService.forgotPassword(email);
        message.info('If your email is registered, you will receive a password reset link')
    }


    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh' }}>
            <h2>Log In</h2>

            <Form
                onFinish={login}
                form={form}
            >
                <Form.Item name='email'>
                    <Input placeholder='Username' />

                </Form.Item>
                <Form.Item name='password'>
                    <Input placeholder='Password' type='password' />
                </Form.Item>

                <Button type='primary' style={{width:'100%'}} htmlType='submit'>Log in</Button>
                <Button type="link" onClick={resetPasswordLink}>
                    Forgot password?
                </Button>
            </Form>
        </div>
    );
};

export default Login;
